import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { PrinterJobItem } from 'src/app/shared/models/PrintJobItem.model';
import { PrintOrder } from 'src/app/shared/models/PrintOrder';

@Component({
	selector: 'app-kitchen-print-orders',
	templateUrl: './kitchen-print-orders.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class KitchenPrintOrdersComponent implements OnInit, OnDestroy {
	printJobSelected: PrinterJobItem;
	printOrderSelected: PrintOrder;

	printOrderList: PrintOrder[];

	kitchenDeviceList: GenericLabelValue[] = [];

	printOrderSubscription: Subscription = new Subscription();

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService) {}
	ngOnDestroy(): void {
		this.printOrderSubscription.unsubscribe();
	}

	ngOnInit(): void {
		this.printOrderSubscription.add(
			this.venueService.printOrderJobs.subscribe((data) => {
				data.sort((a, b) => (a.created < b.created ? 1 : -1));
				this.printOrderList = [...data];
				this.buildDeviceList(this.printOrderList);
			})
		);
		if (this.venueService.printOrderJobs.value.length === 0) {
			this.venueService.printOrdersGet(
				this.venueService.subscriptionVenue.value.key,
				this.app.moment().add(-1, 'days').startOf('day').format(),
				this.app.moment().endOf('day').format()
			);
		} else {
			this.printOrderList = [...this.venueService.printOrderJobs.value];
			this.buildDeviceList(this.printOrderList);
		}
	}

	async refreshPrintJobList() {
		const printOrderCount = this.venueService.printOrderJobs.value.length;
		this.app.loading(true);
		await this.venueService.printOrdersGet();
		this.app.loading(false);

		this.app.msgSvc.add({
			severity: AppMessageSeverity.GREEN,
			summary: '',
			detail: `Print order list refreshed successfully. \n Added ${this.venueService.printOrderJobs.value.length - printOrderCount} print orders.`,
		});
	}

	async getPrintOrder(printOrderKey: string, printerId: number) {
		const resp = await this.focuslink.kitchenJobGet(this.venueService.venueKey, printOrderKey, printerId);
		this.printJobSelected = new PrinterJobItem(resp);
		this.printOrderSelected = this.venueService.printOrderJobs.value.find((i) => i.key === printOrderKey);
	}

	buildDeviceList(printOrders: PrintOrder[]) {
		printOrders.forEach((printOrder) => {
			if (!this.kitchenDeviceList.some((i) => i.value === printOrder.deviceName)) {
				this.kitchenDeviceList.push({
					label: printOrder.deviceName,
					value: printOrder.deviceName,
					meta: 'tablet',
				});
			}
		});
	}
}
